import { AwsUi } from '../../../../core/runtime/src';
import { KeyCode } from '../../../../core/utils/src/dom';
import { getWeekStartByLocale } from 'weekstart/full';
import Header from './header';
import Grid from './grid';
import { isSameMonth, addDays, addWeeks, differenceInMonths, addMonths, startOfMonth } from 'date-fns';
import { normalizeLocale } from './utils/locales';
var shallowCompare = function (obj1, obj2) {
    return Object.keys(obj1).length === Object.keys(obj2).length &&
        Object.keys(obj1).every(function (key) { return Object.prototype.hasOwnProperty.call(obj2, key) && obj1[key] === obj2[key]; });
};
function handleSelectDate(date, handler) {
    handler({ date: date });
}
export default {
    view: function (_a) {
        var _b = _a.attrs, nextMonthLabel = _b.nextMonthLabel, previousMonthLabel = _b.previousMonthLabel, onChangeMonth = _b.onChangeMonth, onSelectDate = _b.onSelectDate, onMouseDown = _b.onMouseDown, selectedDate = _b.selectedDate, isDateEnabled = _b.isDateEnabled, hasFocus = _b.hasFocus, todayLabel = _b.todayLabel, _c = _a.state, keydown = _c.keydown, focusedDate = _c.focusedDate, baseDate = _c.baseDate, normalizedLocale = _c.normalizedLocale, normalizedStartOfWeek = _c.normalizedStartOfWeek, focusFirstButton = _c.focusFirstButton, focusCurrentDate = _c.focusCurrentDate;
        var TabTrap = function (_a) {
            var next = _a.next;
            return (hasFocus ? AwsUi.__createElement("div", { tabindex: "0", onfocus: function (e) { return next(e.target.parentNode); } }) : null);
        };
        return (AwsUi.__createElement("div", { className: "awsui-calendar", role: "application" },
            AwsUi.__createElement(TabTrap, { next: focusCurrentDate }),
            AwsUi.__createElement(Header, { locale: normalizedLocale, baseDate: baseDate, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, calendarHasFocus: hasFocus, onChangeMonth: function (prev) { return onChangeMonth(addMonths(baseDate, prev ? -1 : 1)); } }),
            AwsUi.__createElement("div", { onkeydown: keydown },
                AwsUi.__createElement(Grid, { locale: normalizedLocale, isDateEnabled: isDateEnabled, startOfWeek: normalizedStartOfWeek, selectedDate: selectedDate, focusedDate: focusedDate, baseDate: baseDate, todayLabel: todayLabel, onSelectDate: function (date) { return handleSelectDate(date, onSelectDate); }, onMouseDown: onMouseDown })),
            AwsUi.__createElement(TabTrap, { next: focusFirstButton })));
    },
    oninit: function (_a) {
        var _this = this;
        var attrs = _a.attrs;
        this.setupState = function (_a) {
            var onFocusDate = _a.onFocusDate, onChangeMonth = _a.onChangeMonth, onSelectDate = _a.onSelectDate, displayedDate = _a.displayedDate, focusedDate = _a.focusedDate, selectedDate = _a.selectedDate, isDateEnabled = _a.isDateEnabled, hasFocus = _a.hasFocus, locale = _a.locale, startOfWeek = _a.startOfWeek;
            var handleFocusMove = function (focussed, moveFn) {
                var current = moveFn(focussed);
                if (!isDateEnabled) {
                    return current;
                }
                while (!isDateEnabled(current)) {
                    if (Math.abs(differenceInMonths(focussed, current)) > 1) {
                        // if the entire month in the requested direction has no enabled dates,
                        // we return the currently focused value
                        return focussed;
                    }
                    current = moveFn(current);
                }
                return current;
            };
            var isDateAvailable = function (date) { return date && (!isDateEnabled || isDateEnabled(date)); };
            var selectFocusedDate = function (selected, baseDate) {
                if (isDateAvailable(selected) && isSameMonth(selected, baseDate)) {
                    return selected;
                }
                var today = new Date();
                if (isDateAvailable(today) && isSameMonth(today, baseDate)) {
                    return today;
                }
                if (isDateAvailable(baseDate)) {
                    return baseDate;
                }
                return null;
            };
            _this.normalizedLocale = normalizeLocale(locale);
            _this.normalizedStartOfWeek = (typeof startOfWeek === 'number'
                ? startOfWeek
                : getWeekStartByLocale(_this.normalizedLocale));
            _this.baseDate = startOfMonth(displayedDate);
            if (!isDateAvailable(_this.baseDate)) {
                _this.baseDate = handleFocusMove(_this.baseDate, function (date) { return addDays(date, 1); });
            }
            _this.focusedDate = hasFocus && (focusedDate || selectFocusedDate(selectedDate, _this.baseDate));
            _this.keydown = function (e) {
                switch (e.keyCode) {
                    default:
                        return;
                    case KeyCode.enter:
                        e.preventDefault();
                        if (focusedDate || _this.focusedDate) {
                            onFocusDate({ date: null });
                            onSelectDate({ date: focusedDate || _this.focusedDate });
                        }
                        return;
                    case KeyCode.right:
                        e.preventDefault();
                        focusedDate = handleFocusMove(_this.focusedDate, function (date) { return addDays(date, 1); });
                        break;
                    case KeyCode.left:
                        e.preventDefault();
                        focusedDate = handleFocusMove(_this.focusedDate, function (date) { return addDays(date, -1); });
                        break;
                    case KeyCode.up:
                        e.preventDefault();
                        focusedDate = handleFocusMove(_this.focusedDate, function (date) { return addWeeks(date, -1); });
                        break;
                    case KeyCode.down:
                        e.preventDefault();
                        focusedDate = handleFocusMove(_this.focusedDate, function (date) { return addWeeks(date, 1); });
                        break;
                }
                if (!isSameMonth(focusedDate, _this.baseDate)) {
                    onChangeMonth(focusedDate);
                }
                onFocusDate({ date: focusedDate });
            };
            _this.focusCurrentDate = function (container) {
                var date = container.querySelector('.awsui-calendar__date--focusable');
                if (date) {
                    date.focus();
                }
            };
            _this.focusFirstButton = function (container) {
                container.querySelector('awsui-button').component.focus();
            };
        };
        this.setupState(attrs);
    },
    onbeforeupdate: function (_a, _b) {
        var attrs = _a.attrs;
        var oldAttrs = _b.attrs, oldState = _b.state;
        if (shallowCompare(attrs, oldAttrs) &&
            (oldState.focusedDate || '').toString() === (this.focusedDate || '').toString() &&
            oldState.baseDate.toString() === this.baseDate.toString()) {
            return false;
        }
        this.setupState(attrs);
    },
    onupdate: function (_a) {
        var dom = _a.dom, _b = _a.attrs, hasFocus = _b.hasFocus, focusedDate = _b.focusedDate, _c = _a.state, focusCurrentDate = _c.focusCurrentDate, focusFirstButton = _c.focusFirstButton, baseDate = _c.baseDate;
        if (focusedDate && isSameMonth(baseDate, focusedDate)) {
            focusCurrentDate(dom);
        }
        if (hasFocus && !dom.contains(document.activeElement)) {
            // wait for nested components to rerender, then focus first button
            setTimeout(function () {
                focusFirstButton(dom);
            });
        }
    }
};
//# sourceMappingURL=calendar.js.map